import { useFormContext } from 'react-hook-form'
import { OptionCard } from '../ui/OptionCard'
import type { FormData } from './FormWizard'

const budgetOptions = [
  {
    value: 'under-1k',
    label: 'Under $1,000',
    description: 'Small maintenance or repairs',
  },
  {
    value: '1k-5k',
    label: '$1,000 - $5,000',
    description: 'Basic setup or significant repairs',
  },
  {
    value: '5k-15k',
    label: '$5,000 - $15,000',
    description: 'Quality custom installation',
  },
  {
    value: '15k-50k',
    label: '$15,000 - $50,000',
    description: 'Premium custom aquarium',
  },
  {
    value: 'over-50k',
    label: '$50,000+',
    description: 'Large-scale luxury installation',
  },
  {
    value: 'unsure',
    label: 'Not sure yet',
    description: "I'd like to discuss options",
  },
]

export function StepBudget() {
  const { register, watch } = useFormContext<FormData>()
  const selectedBudget = watch('budget')

  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          What's your budget range?
        </h2>
        <p className="text-gray-600">
          This is optional and helps us tailor our recommendations
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {budgetOptions.map((option) => (
          <OptionCard
            key={option.value}
            {...register('budget')}
            value={option.value}
            label={option.label}
            description={option.description}
            selected={selectedBudget === option.value}
          />
        ))}
      </div>

      <p className="text-sm text-gray-500 text-center mt-4">
        Skip this step if you prefer to discuss budget later
      </p>
    </div>
  )
}
